import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { TemplateView } from 'app/models/template-view';
 

@Component({
  selector: 'app-template-dialog',
  templateUrl: './template-dialog.component.html',
  styleUrls: ['./template-dialog.component.scss'],
  standalone: false
})
export class TemplateDialogComponent implements OnInit {

  template: TemplateView
  myForm: FormGroup;
  isDefault = false;
  overWrite = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder ) {
  }

  isAdmin = false;
  ngOnInit(): void {
    //console.log("I got this data", this.data)


    let user = JSON.parse(localStorage.getItem('curUserData') || '{}');
    let groups = user.groups || [];
    this.isAdmin = groups.includes('Template Manager');

    this.template = this.data;
    if (this.template.templateViewID === 0) {
      this.template.globalView = false;
      this.template.publicView = false;
    } else {
      this.overWrite = true;
    }
    var obj = this.template;

    //ANNOYING SQL SERVER STUFF
    if (obj.publicView.toString() == "False") { obj.publicView = false; }
    if (obj.globalView.toString() == "False") { obj.globalView = false; }
    if (obj.globalView.toString() == "True") { obj.publicView = true; }
    if (obj.globalView.toString() == "True") { obj.globalView = true; }
    //END ANNOYING SQL SERVER STUFF

    if (obj.templateViewName == 'Default') this.isDefault = true;
    this.myForm = this.fb.group({
      templateViewID: new FormControl(obj.templateViewID || 0),
      templateViewName: new FormControl(obj.templateViewName || '', Validators.required),
      globalView: new FormControl(obj.globalView || false,),
      publicView: new FormControl(obj.publicView || false),
      status: new FormControl('Active'),
      pageCode: new FormControl('JOBMASTER'),
    });
  }

  onNoClick(){
    this.dialogRef.close();
  }
  btnCancel(){
    this.dialogRef.close();
  }

  btnSave(){
    this.dialogRef.close(this.myForm.value);
  }

  btnSaveAs(){
    this.myForm.controls["templateViewID"].setValue(0);
    this.myForm.controls["templateViewName"].setValue("Copy of " + this.template.templateViewName);
    this.overWrite = false;
  }
  
  btnDelete(){
    let deleteTemplate = confirm("Are you sure you want to delete this template?");
    if(deleteTemplate){
      this.myForm.controls["status"].setValue("DELETED");
      this.dialogRef.close(this.myForm.value);
    }
  }
}
